export const BUSINESS_SUBMIT_STEPS = {
	BASE_INFORMATION: 'base_information',
	CONTACT_INFORMATION: 'contact_information',
	TIMING_INFORMATION: 'timing_information',
	LICENSE_INFORMATION: 'license_information',
};
